import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import { Done } from '@mui/icons-material';

import { JourneyButton } from '../StorySection/styles';
import { MISSION_CONTENT, COMMITMENTS } from './constants';
import {
  MissionSectionWrapper,
  MissionContainer,
  MissionLeftColumn,
  MissionTitle,
  MissionText,
  MissionButtonContainer,
  MissionRightColumn,
  CommitmentTitle,
  CommitmentsContainer,
  StyledCommitmentPill,
} from './styles';

const MissionSection = () => {
  const navigate = useNavigate();

  const handleExploreServicesClick = () => {
    navigate('/services');
  };

  return (
    <MissionSectionWrapper>
      <MissionContainer>
        <MissionLeftColumn>
          <MissionTitle>{MISSION_CONTENT.title}</MissionTitle>

          <MissionText>{MISSION_CONTENT.description}</MissionText>

          <MissionButtonContainer>
            <JourneyButton variant="contained" onClick={handleExploreServicesClick}>
              {MISSION_CONTENT.buttonText}
            </JourneyButton>
          </MissionButtonContainer>
        </MissionLeftColumn>

        <MissionRightColumn>
          <Stack spacing={2.2}>
            <CommitmentTitle>{MISSION_CONTENT.commitmentTitle}</CommitmentTitle>

            <CommitmentsContainer>
              {COMMITMENTS.map((commitment, index) => (
                <StyledCommitmentPill key={index} elevation={0}>
                  <Done />
                  {commitment}
                </StyledCommitmentPill>
              ))}
            </CommitmentsContainer>
          </Stack>
        </MissionRightColumn>
      </MissionContainer>
    </MissionSectionWrapper>
  );
};

export default MissionSection;
